export const gtmTagDetails = [{
    tagName: 'Header Manage Orders',
    tagDetails: {
        event: 'navigation',
        navLocation: 'header',
        navElementText: 'Manage Orders',
        navURL: '/manageorders'
    }
}, {
    tagName: 'Footer Government',
    tagDetails: {
        event: 'navigation',
        navLocation: 'footer',
        navElementText: 'Government',
    }
}, {
    tagName: 'Footer Contact Us',
    tagDetails: {
        event: 'navigation',
        navLocation: 'footer',
        navElementText: 'Contact Us',
    }
}, {
    tagName: 'Header Logout',
    tagDetails: {
        event: 'navigation',
        navLocation: 'header',
        navElementText: 'Logout',
    }
}, {
    tagName: 'Header List',
    tagDetails: {
        event: 'navigation',
        navLocation: 'header',
        navElementText: 'List',
    }
}, {
    tagName: 'Header Cart',
    tagDetails: {
        event: 'navigation',
        navLocation: 'header',
        navElementText: 'Cart',
    }
}, {
    tagName: 'Header View Invoices',
    tagDetails: {
        event: 'navigation',
        navLocation: 'header',
        navElementText: 'View Invoices',
    }
}, {
    tagName: 'Header Quick Order',
    tagDetails: {
        event: 'navigation',
        navLocation: 'header',
        navElementText: 'Quick Order',
        navURL: '/quickorder'
    }
},{
    tagName: 'Header Approve NCRP',
    tagDetails: {
        event: 'navigation',
        navLocation: 'header',
        navElementText: 'Approve NCRP',
        navURL: '/approve-ncrp'
    }
}, {
    tagName: 'Header Carrier Information',
    tagDetails: {
        event: 'navigation',
        navLocation: 'header',
        navElementText: 'Carrier Information',
        navURL: '/carrierinformation'
    }
}, {
    tagName: 'Header Create Brochure',
    tagDetails: {
        event: 'navigation',
        navLocation: 'header',
        navElementText: 'Create Brochure',
        navURL: '/list'
    }
}, {
    tagName: 'Header Saved Brochures',
    tagDetails: {
        event: 'navigation',
        navLocation: 'header',
        navElementText: 'Saved Brochures',
        navURL: '/savedbrochures'
    }
}, {
    tagName: 'Header Create Price Tags',
    tagDetails: {
        event: 'navigation',
        navLocation: 'header',
        navElementText: 'Create Price Tags',
        navURL: '/list'
    }
}, {
    tagName: 'Header Look Up Serial Numbers',
    tagDetails: {
        event: 'navigation',
        navLocation: 'header',
        navElementText: 'Look Up Serial Numbers',
        navURL: '/lookupserialno'
    }
}, {
    tagName: 'Header Site Management',
    tagDetails: {
        event: 'navigation',
        navLocation: 'header',
        navElementText: 'Site Management',
        navURL: '/siteManagement'
    }
}, {
    tagName: 'Header Price Sheets',
    tagDetails: {
        event: 'navigation',
        navLocation: 'header',
        navElementText: 'Price Sheets',
        navURL: '/resources/pricesheets'
    }
},  {
    tagName: 'Header Advertising Portal',
    tagDetails: {
        event: 'navigation',
        navLocation: 'header',
        navElementText: 'Advertising Portal',
        navURL: '/resources/advertisingportal'
    }
}, {
    tagName: 'Header Export Product & Pricing Information',
    tagDetails: {
        event: 'navigation',
        navLocation: 'header',
        navElementText: 'Export Product & Pricing Information',
        navURL: '/saved-exports'
    }
}, {
    tagName: 'Header Performance Volume Rebate Tracker',
    tagDetails: {
        event: 'navigation',
        navLocation: 'header',
        navElementText: 'Performance Volume Rebate Tracker',
        navURL: '/resources/performance'
    }
}, {
    tagName: 'Header Monogram Volume Rebate Tracker',
    tagDetails: {
        event: 'navigation',
        navLocation: 'header',
        navElementText: 'Monogram Volume Rebate Tracker',
        navURL: '/resources/monogram'
    }
},{
    tagName: 'Header 100% GE Appliances Distributor PIF',
    tagDetails: {
        event: 'navigation',
        navLocation: 'header',
        navElementText: '100% GE Appliances Distributor PIF',
        navURL: '/resources/gedistributor'
    }
}, {
    tagName: 'Header Prestige PIF Tracker',
    tagDetails: {
        event: 'navigation',
        navLocation: 'header',
        navElementText: 'Prestige PIF Tracker',
        navURL: '/resources/prestigepif'
    }
}, {
    tagName: 'Header GEA Learning Portal',
    tagDetails: {
        event: 'navigation',
        navLocation: 'header',
        navElementText: 'GEA Learning Portal',
    }
}, {
    tagName: 'Header Capital Solutions for the Home Product Industry',
    tagDetails: {
        event: 'navigation',
        navLocation: 'header',
        navElementText: 'Capital Solutions for the Home Product Industry',
    }
}, {
    tagName: 'Header CustomerNet Training',
    tagDetails: {
        event: 'navigation',
        navLocation: 'header',
        navElementText: 'CustomerNet Training',
    }
}, {
    tagName: 'Header CustomerNet Help Desk',
    tagDetails: {
        event: 'navigation',
        navLocation: 'header',
        navElementText: 'CustomerNet Help Desk',
    }
}, {
    tagName: 'Header Backorders Available',
    tagDetails: {
        event: 'navigation',
        navLocation: 'header',
        navElementText: 'Backorders Available',
    }
}, {
    tagName: 'Header Help',
    tagDetails: {
        event: 'navigation',
        navLocation: 'header',
        navElementText: 'Help',
    }
}, {
    tagName: 'Header My Profile',
    tagDetails: {
        event: 'navigation',
        navLocation: 'header',
        navElementText: 'My Profile',
    }
}, {
    tagName: 'Header MAP Guidelines',
    tagDetails: {
        event: 'navigation',
        navLocation: 'header',
        navElementText: 'MAP Guidelines',
        navURL: '/resources/mapguidelines'
    }
}, {
    tagName: 'Header Request Return',
    tagDetails: {
        event: 'navigation',
        navLocation: 'header',
        navElementText: 'Request Return',
        navURL: '/requestreturn'
    }
}, {
    tagName: 'Header Request Credit',
    tagDetails: {
        event: 'navigation',
        navLocation: 'header',
        navElementText: 'Request Credit',
        navURL: '/requestcredit'
    }
}, {
    tagName: 'Header View Returns & Credits',
    tagDetails: {
        event: 'navigation',
        navLocation: 'header',
        navElementText: 'View Returns & Credits',
        navURL: '/viewrequests'
    }
}, {
    tagName: 'Header Create Package',
    tagDetails: {
        event: 'navigation',
        navLocation: 'header',
        navElementText: 'Create Package',
        navURL: '/createpackage'
    }
}, {
    tagName: 'Header Approve Returns and Credits',
    tagDetails: {
        event: 'navigation',
        navLocation: 'header',
        navElementText: 'Approve Returns and Credits',
        navURL: '/approvereturns'
    }
}, {
    tagName: 'Header Search & Pay Invoices',
    tagDetails: {
        event: 'navigation',
        navLocation: 'header',
        navElementText: 'Search & Pay Invoices',
    }
}, {
    tagName: 'Header Product Line',
    tagDetails: {
        event: 'navigation',
        navLocation: 'header',
    }
}, {
    tagName: 'Header Packages',
    tagDetails: {
        event: 'navigation',
        navLocation: 'header',
    }
}, {
    tagName: 'Prelogin Product Line',
    tagDetails: {
        event: 'prelogin',
        navLocation: 'Login',
    }
}, {
    tagName: 'Postlogin Search Result Filter',
    tagDetails: {
        event: 'filter-results',
    }
}, {
    tagName: 'Prelogin Search Result Filter',
    tagDetails: {
        event: 'filter-results',
    }
}, {
    tagName: 'Carrier Search',
    tagDetails: {
        event: 'search-submit',
    }
}, {
    tagName: 'Lookup Serial Number Search',
    tagDetails: {
        event: 'search-submit',
    }
}, {
    tagName: 'Product Number Search',
    tagDetails: {
        event: 'search-submit',
    }
}, {
    tagName: 'Header Coop Advertising',
    tagDetails: {
        event: 'navigation',
        navLocation: 'header',
        navElementText: 'Coop Advertising',
    }
}, {
    tagName: 'Header Product Catalogs',
    tagDetails: {
        event: 'navigation',
        navLocation: 'header',
        navElementText: 'Product Catalogs',
    }
}, {
    tagName: 'Header GE 2020 CAD Catalog',
    tagDetails: {
        event: 'navigation',
        navLocation: 'header',
        navElementText: 'GE 2020 CAD Catalog',
    }
}, {
    tagName: 'Header Kitchen Design Center',
    tagDetails: {
        event: 'navigation',
        navLocation: 'header',
        navElementText: 'Kitchen Design Center',
    }
}, {
    tagName: 'Header Customer Agreement Handbooks',
    tagDetails: {
        event: 'navigation',
        navLocation: 'header',
        navElementText: 'Customer Agreement Handbooks',
    }
}, {
    tagName: 'Header Request Product & Price Content',
    tagDetails: {
        event: 'navigation',
        navLocation: 'header',
        navElementText: 'Request Product & Price Content',
    }
}, {
    tagName: 'Header Product Purchase Report',
    tagDetails: {
        event: 'navigation',
        navLocation: 'header',
        navElementText: 'Product Purchase Report',
    }
}, {
    tagName: 'Header Consumer Rebates & Claim Forms',
    tagDetails: {
        event: 'navigation',
        navLocation: 'header',
        navElementText: 'Consumer Rebates & Claim Forms',
    }
}, {
    tagName: 'Home Page Links',
    tagDetails: {
        event: 'navigation',
        navLocation: 'homepage'
    }
}, {
    tagName: 'Add to List',
    tagDetails: {
        event: 'wishlist-add'
    }
}, {
    tagName: 'Remove from List',
    tagDetails: {
        event: 'wishlist-remove'
    }
}, {
    tagName: 'List View',
    tagDetails: {
        event: 'wishlist-view'
    }
}, {
    tagName: 'Cart View',
    tagDetails: {
        event: 'view-cart'
    }
}, {
    tagName: 'Quick Order Import',
    tagDetails: {
        event: 'quick-order'
    }
}, {
    tagName: 'Order Review Enter Order',
    tagDetails: {
        event: 'enter-order'
    }
}, {
    tagName: 'Manage Order Cancel Order',
    tagDetails: {
        event: 'cancel-order'
    }
}, {
    tagName: 'Manage Order View Status',
    tagDetails: {
        event: 'order-status'
    }
}, {
    tagName: 'Manage Order Search',
    tagDetails: {
        event: 'order-search',
    }
}, {
    tagName: 'Manage Order View Order',
    tagDetails: {
        event: 'order-view',
    }
}, {
    tagName: 'Update Booked Order Cancel Order',
    tagDetails: {
        event: 'cancel-order'
    }
}, {
    tagName: 'Update Booked Save and Continue',
    tagDetails: {
        event: 'update-order'
    }
}, {
    tagName: 'Add to Cart',
    tagDetails: {
        event: 'add-to-cart'
    }
}, {
    tagName: 'Remove from Cart',
    tagDetails: {
        event: 'remove-from-cart'
    }
}, {
    tagName: 'Product Click',
    tagDetails: {
        event: 'product-click'
    }
}, {
    tagName: 'Product Details Page',
    tagDetails: {
        event: 'product-detail-view'
    }
}, {
    tagName: 'Checkout Step',
    tagDetails: {
        event: 'checkout-step'
    }
}, {
    tagName: 'Checkout Option',
    tagDetails: {
        event: 'checkout-option'
    }
}, {
    tagName: 'Transaction',
    tagDetails: {
        event: 'transaction'
    }
}];



// WEBPACK FOOTER //
// ./src/App/redux/util/tag-details.js